export default {
  type: 'editor.elements.TabsElement',
  name: 'Tabs',
  editModeTitle: 'Manage Tabs',
  icon: 'M19,19H5V5H12V9H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z',
  order: 40,
  tooltip: 'Adding tabs will shorten your page and make it much easier to navigate. For example Shipping, Payment, Return policies.',
};
